import { useEffect, useReducer, useRef } from 'react';
import createAdvertisingModel from './createAdvertisingModel';
import { AdvertisingModelOptions, AdvertisingPoint } from './types';

const usePointAdvertisingSettings = (point: AdvertisingPoint | undefined, options: AdvertisingModelOptions) => {
  const optionsRef = useRef(options);
  optionsRef.current = options;
  const modelRef = useRef<ReturnType<typeof createAdvertisingModel> | undefined>(undefined);
  if (!modelRef.current) {
    modelRef.current = createAdvertisingModel({
      save: (input) => optionsRef.current.save(input),
      read: (id) => optionsRef.current.read(id),
      onError: () => optionsRef.current.onError(),
    });
  }
  const model = modelRef.current;
  const [, rerender] = useReducer((version) => version + 1, 0);

  useEffect(() => {
    model.activate();
    const unsubscribe = model.subscribe(rerender);
    return () => {
      unsubscribe();
      model.dispose();
    };
  }, [model]);

  useEffect(() => {
    if (point) model.sync(point);
  }, [model, point]);

  return { advertisingSettings: model.get(point?.id), changeAdvertisingSettings: model.change };
};

export default usePointAdvertisingSettings;
